/* import __COLOCATED_TEMPLATE__ from './overview.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _dec, _dec2, _dec3, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { restartableTask } from 'ember-concurrency';
import { validatable, Length, BeforeDate, AfterDate } from 'ilios-common/decorators/validation';
import { findById } from 'ilios-common/utils/array-helpers';
import { TrackedAsyncData } from 'ember-async-data';
let CourseOverview = (_dec = Length(2, 255), _dec2 = BeforeDate('endDate', {
  granularity: 'day'
}), _dec3 = AfterDate('startDate', {
  granularity: 'day'
}), validatable(_class = (_class2 = class CourseOverview extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "currentUser", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "permissionChecker", _descriptor3, this);
    _initializerDefineProperty(this, "router", _descriptor4, this);
    _initializerDefineProperty(this, "store", _descriptor5, this);
    _defineProperty(this, "universalLocator", 'ILIOS');
    _initializerDefineProperty(this, "externalId", _descriptor6, this);
    _initializerDefineProperty(this, "startDate", _descriptor7, this);
    _initializerDefineProperty(this, "endDate", _descriptor8, this);
    _initializerDefineProperty(this, "level", _descriptor9, this);
    _initializerDefineProperty(this, "levelOptions", _descriptor10, this);
    _initializerDefineProperty(this, "clerkshipTypeId", _descriptor11, this);
    _initializerDefineProperty(this, "clerkshipTypeOptions", _descriptor12, this);
    _defineProperty(this, "revertClerkshipTypeChanges", _buildTask(() => ({
      context: this,
      generator: function* () {
        const clerkshipType = yield this.args.course.clerkshipType;
        if (clerkshipType) {
          this.clerkshipTypeId = clerkshipType.id;
        } else {
          this.clerkshipTypeId = null;
        }
      }
    }), null, "revertClerkshipTypeChanges", "restartable"));
    _defineProperty(this, "changeStartDate", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.addErrorDisplayFor('startDate');
        const isValid = yield this.isValid('startDate');
        if (!isValid) {
          return false;
        }
        this.removeErrorDisplayFor('startDate');
        this.args.course.set('startDate', this.startDate);
        yield this.args.course.save();
        this.startDate = this.args.course.startDate;
      }
    }), null, "changeStartDate", "restartable"));
    _defineProperty(this, "changeEndDate", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.addErrorDisplayFor('endDate');
        const isValid = yield this.isValid('endDate');
        if (!isValid) {
          return false;
        }
        this.removeErrorDisplayFor('endDate');
        this.args.course.set('endDate', this.endDate);
        yield this.args.course.save();
        this.endDate = this.args.course.endDate;
      }
    }), null, "changeEndDate", "restartable"));
    _defineProperty(this, "changeExternalId", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.addErrorDisplayFor('externalId');
        const isValid = yield this.isValid('externalId');
        if (!isValid) {
          return false;
        }
        this.removeErrorDisplayFor('externalId');
        this.args.course.set('externalId', this.externalId);
        yield this.args.course.save();
        this.externalId = this.args.course.externalId;
      }
    }), null, "changeExternalId", "restartable"));
    const {
      course
    } = this.args;
    this.clerkshipTypeOptions = this.store.peekAll('course-clerkship-type');
    this.externalId = course.externalId;
    this.startDate = course.startDate;
    this.endDate = course.endDate;
    this.level = course.level;
    this.clerkshipTypeId = course.belongsTo('clerkshipType').id();
  }
  get schoolData() {
    return new TrackedAsyncData(this.args.course.school);
  }
  get canCreateCourseInSchoolData() {
    return new TrackedAsyncData(this.permissionChecker.canCreateCourse(this.schoolData.value));
  }
  get canCreateCourseInSchool() {
    return this.schoolData.isResolved && this.canCreateCourseInSchoolData.isResolved ? this.canCreateCourseInSchoolData.value : false;
  }
  get selectedClerkshipType() {
    if (!this.clerkshipTypeId) {
      return null;
    }
    return findById(this.clerkshipTypeOptions, this.clerkshipTypeId);
  }
  get showRollover() {
    if (this.router.currentRouteName === 'course.rollover') {
      return false;
    }
    return this.canCreateCourseInSchool;
  }
  get clerkshipTypeTitle() {
    if (!this.selectedClerkshipType) {
      return this.intl.t('general.notAClerkship');
    }
    return this.selectedClerkshipType.title;
  }
  async changeClerkshipType() {
    this.args.course.set('clerkshipType', this.selectedClerkshipType);
    return this.args.course.save();
  }
  setCourseClerkshipType(event) {
    let id = event.target.value;
    //convert the string 'null' to a real null
    if (id === 'null') {
      id = null;
    }
    this.clerkshipTypeId = id;
  }
  revertStartDateChanges() {
    this.startDate = this.args.course.startDate;
  }
  revertEndDateChanges() {
    this.endDate = this.args.course.endDate;
  }
  revertExternalIdChanges() {
    this.externalId = this.args.course.externalId;
  }
  setLevel(event) {
    this.level = parseInt(event.target.value, 10);
  }
  async changeLevel() {
    this.args.course.set('level', this.level);
    return this.args.course.save();
  }
  revertLevelChanges() {
    this.level = this.args.course.level;
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "permissionChecker", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "externalId", [_dec, tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "startDate", [_dec2, tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "endDate", [_dec3, tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "level", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "levelOptions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "clerkshipTypeId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "clerkshipTypeOptions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "schoolData", [cached], Object.getOwnPropertyDescriptor(_class2.prototype, "schoolData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "canCreateCourseInSchoolData", [cached], Object.getOwnPropertyDescriptor(_class2.prototype, "canCreateCourseInSchoolData"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeClerkshipType", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "changeClerkshipType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setCourseClerkshipType", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "setCourseClerkshipType"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "revertStartDateChanges", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "revertStartDateChanges"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "revertEndDateChanges", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "revertEndDateChanges"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "revertExternalIdChanges", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "revertExternalIdChanges"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setLevel", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "setLevel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeLevel", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "changeLevel"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "revertLevelChanges", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "revertLevelChanges"), _class2.prototype), _class2)) || _class);
export { CourseOverview as default };